export const SubscriptionSource = {
  File: "file",
  Manual: "manual",
  NoUpdate: "noUpdate",
};
